import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import {
  Dashboard as DashboardIcon,
  Monitor as MonitorIcon,
  Settings as SettingsIcon,
  BarChart as ReportsIcon,
  People as UsersIcon,
  Notifications as NotificationsIcon,
  Receipt as TransactionsIcon,
  Receipt as InvoicesIcon,
  Business as MerchantIcon,
  Webhook as WebhookIcon,
  Group as TeamsIcon,
  Person as PersonIcon,
  AccountBalance as SettlementIcon,
  Payment as PaymentIcon,
  SwapCalls as SwapCallsIcon,
} from '@mui/icons-material';
import type { MenuItem, HeaderAction } from '@/components/layout';

// Helper function to create menu items safely
const createMenuItem = (
  id: string,
  text: string,
  iconComponent: React.ReactElement,
  path: string,
  options?: Partial<MenuItem>
): MenuItem => ({
  id,
  text,
  icon: iconComponent,
  path,
  ...options,
});

// Default menu configuration for merchant dashboard
export const merchantMenuItems: MenuItem[] = [

  createMenuItem('dashboard', 'Home', React.createElement(MonitorIcon), '/dashboard'),

  createMenuItem(
    'merchant-connections',
    'Connections',
    React.createElement(TransactionsIcon),
    '/merchant/connections'
  ),

  createMenuItem(
    'merchant/routing-rules',
    'Routing',
    React.createElement(WebhookIcon),
    '/merchant/routing-rule'
  ),


  createMenuItem(
    'merchant-transactions',
    'Payments',
    React.createElement(PaymentIcon),
    '/merchant/transactions'
  ),

  createMenuItem(
    'merchant-settlements',
    'Reconciliations',
    React.createElement(SwapCallsIcon),
    '/merchant/settlements'
  ),

  createMenuItem(
    'merchant-invoices',
    'Invoices',
    React.createElement(InvoicesIcon),
    '/merchant/invoices'
  ),

  createMenuItem(
    'merchant-test',
    'Simulate',
    React.createElement(WebhookIcon),
    '/merchant/test'
  ),

  createMenuItem(
    'merchant-webhooks',
    'Webhooks',
    React.createElement(WebhookIcon),
    '/merchant/webhooks'
  ),

  // createMenuItem(
  //   'merchant-teams',
  //   'Teams',
  //   React.createElement(TeamsIcon),
  //   '/merchant/teams'
  // ),



  // createMenuItem('profile', 'Profile', React.createElement(ProfileIcon), '/profile'),
  // createMenuItem('settings', 'Settings', React.createElement(SettingsIcon), '/settings'),
];


// Default menu configuration for merchant dashboard
export const teamUseruItems: MenuItem[] = [
  createMenuItem('dashboard', 'Dashboard', React.createElement(DashboardIcon), 'teamuUser/dashboard'),
  createMenuItem('merchant', 'Merchant', React.createElement(MerchantIcon), '', {
    children: [
      createMenuItem(
        'teamuUser-transactions',
        'Transactions',
        React.createElement(TransactionsIcon),
        '/teamuUser/transactions'
      ),
      createMenuItem(
        'teamuUser-webhooks',
        'Webhooks',
        React.createElement(WebhookIcon),
        '/teamuUser/webhooks'
      ),
      createMenuItem(
        'teamuUser-test',
        'Test',
        React.createElement(WebhookIcon),
        '/teamuUser/test'
      ),
    ],
  }),
  // createMenuItem('profile', 'Profile', React.createElement(ProfileIcon), '/profile'),
  // createMenuItem('settings', 'Settings', React.createElement(SettingsIcon), '/settings'),
];

// Team User menu configuration
export const teamUserMenuItems: MenuItem[] = [
  createMenuItem('team-dashboard', 'Dashboard', React.createElement(DashboardIcon), '/teamUser/dashboard'),
  createMenuItem('team-transactions', 'Transactions', React.createElement(TransactionsIcon), '/teamUser/transactions'),
];

// Admin menu configuration
export const adminMenuItems: MenuItem[] = [
  createMenuItem(
    'dashboard',
    'Admin Dashboard',
    React.createElement(DashboardIcon),
    '/admin/dashboard'
  ),
  createMenuItem('merchants', 'Merchants', React.createElement(UsersIcon), '/admin/merchants', {
    badge: 'new',
  }),
  createMenuItem('reports', 'System Reports', React.createElement(ReportsIcon), '/admin/reports'),
  createMenuItem(
    'settings',
    'System Settings',
    React.createElement(SettingsIcon),
    '/admin/settings'
  ),
];

// Header actions configuration
export const defaultHeaderActions: HeaderAction[] = [
  {
    id: 'notifications',
    label: 'Notifications',
    icon: React.createElement(NotificationsIcon),
    onClick: () => {
      console.log('Open notifications');
    },
  },
];

// Function to get menu items based on user role
export const getMenuItemsForRole = (role: string): MenuItem[] => {
  switch (role) {
    case 'admin':
      return adminMenuItems;
    case 'teamUser':
      return teamUserMenuItems;
    case 'merchant':
    default:
      return merchantMenuItems;
  }
};

// Function to get header actions based on user role
export const getHeaderActionsForRole = (role: string): HeaderAction[] => {
  switch (role) {
    case 'admin':
      return [
        ...defaultHeaderActions,
        {
          id: 'admin-panel',
          label: 'Admin Panel',
          onClick: () => {
            console.log('Open admin panel');
          },
        },
      ];
    case 'teamUser':
      return defaultHeaderActions;
    case 'merchant':
    default:
      return defaultHeaderActions;
  }
};

// Simple menu items for basic setup (used in current MainLayout)
export const basicMenuItems: MenuItem[] = [
  createMenuItem('dashboard', 'Dashboard', React.createElement(DashboardIcon), '/dashboard'),
  createMenuItem('merchant', 'Merchant', React.createElement(MerchantIcon), '', {
    children: [
      // createMenuItem(
      //   'merchant-dashboard',
      //   'Dashboard',
      //   React.createElement(DashboardIcon),
      //   '/merchant/dashboard'
      // ),
      createMenuItem(
        'merchant-transactions',
        'Transactions',
        React.createElement(TransactionsIcon),
        '/merchant/transactions'
      ),
      createMenuItem(
        'merchant-webhooks',
        'Webhooks',
        React.createElement(WebhookIcon),
        '/merchant/webhooks'
      ),
      createMenuItem(
        'merchant-teams',
        'Teams',
        React.createElement(TeamsIcon),
        '/merchant/teams'
      ),
      createMenuItem(
        'merchant-test',
        'Test',
        React.createElement(WebhookIcon),
        '/merchant/test'
      ),
    ],
  }),
  // createMenuItem('profile', 'Profile', React.createElement(ProfileIcon), '/profile'),
  // createMenuItem('settings', 'Settings', React.createElement(SettingsIcon), '/settings'),
];
